export const TECHS = [
  {
    name: "cpp",
    title: "C++",
    icon: "img/icons/cpp.webp",
    link: "https://wikipedia.org/wiki/C++",
    top,
  },
  {
    name: "arduino",
    title: "Arduino",
    icon: "img/icons/arduino.webp",
    link: "https://www.arduino.cc",
    top,
  },
  {
    name: "python",
    title: "Python",
    icon: "img/icons/python.webp",
    link: "https://www.python.org",
    top,
  },
  {
    name: "react",
    title: "React",
    icon: "img/icons/react.webp",
    link: "https://react.dev",
    top,
  },
  {
    name: "html",
    title: "HTML5",
    icon: "img/icons/html.webp",
    link: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    top,
  },
  {
    name: "tailwindcss",
    title: "TailwindCSS",
    icon: "img/icons/tailwindcss.webp",
    link: "https://tailwindcss.com",
    top,
  },
  {
    name: "css",
    title: "CSS3",
    icon: "img/icons/css.webp",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    top,
  },
  {
    name: "javascript",
    title: "JavaScript",
    icon: "img/icons/javascript.webp",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    top,
  },
  {
    name: "lua",
    title: "Lua",
    icon: "img/icons/lua.webp",
    link: "https://www.lua.org",
  },
  {
    name: "typescript",
    title: "TypeScript",
    icon: "img/icons/typescript.webp",
    link: "https://www.typescriptlang.org",
    top,
  },
  {
    name: "powerapps",
    title: "Power Apps",
    icon: "img/icons/powerapps.webp",
    link: "https://powerapps.com",
  },
  {
    name: "figma",
    title: "Figma",
    icon: "img/icons/figma.webp",
    link: "https://www.figma.com",
  },
  {
    name: "supabase",
    title: "Supabase",
    icon: "img/icons/supabase.webp",
    link: "https://supabase.com",
  },
  {
    name: "nodejs",
    title: "Node.js",
    icon: "img/icons/nodejs.webp",
    link: "https://nodejs.org",
  },
  {
    name: "cobol",
    title: "COBOL",
    icon: "img/icons/cobol.webp",
    link: "https://wikipedia.org/wiki/COBOL",
  },
];

export const SOFT_SKILLS = [
  {
    name: "communication",
    title: "Comunicación",
    icon: "",
    link: "",
  },
  {
    name: "teamwork",
    title: "Trabajo en Equipo",
    icon: "",
    link: "",
  },
  {
    name: "critical_thinking",
    title: "Pensamiento Crítico",
    icon: "",
    link: "",
  },
  {
    name: "english",
    title: "Inglés",
    icon: "",
    link: "",
  },
];

export const TYPEWRITTER_HEADER = [
  { subtitle: "Hola, mi nombre es", title: "Franco Martino." },
  { subtitle: "Estoy estudiando para ser", title: "Ingeniero Informático." },
  { subtitle: "Actualmente soy", title: "Técnico Electrónico." },
];

export const EDUCATIONS = [
  {
    title: "Ingeniería en Informática",
    institution: "UADE",
    startYear: 2025,
  },
  {
    title: "Tramo de Formación Pedagógica",
    institution: "UFASTA",
    startYear: 2024,
    endYear: 2025,
  },
  {
    title: "Técnicatura en Electrónica",
    institution: "EEST N°3",
    startYear: 2018,
    endYear: 2024,
  },
];

export const COURSES = [
  {
    title: "Certificación - English C2 Proficient",
    institution: "EF SET",
    startYear: 2026,
  },
  {
    title: "Curso - Cybersecurity Fundamentals",
    institution: "Palo Alto Networks",
    startYear: 2026,
  },
  {
    title: "Curso - IBM COBOL Basics",
    institution: "IBM",
    startYear: 2026,
  },
  {
    title: "Curso - Scientific Computing with Python",
    institution: "freeCodeCamp",
    startYear: 2025,
  },
  {
    title: "Curso - Networking Basics",
    institution: "Cisco Networking Academy",
    startYear: 2024,
  },
  {
    title: "Certificación - Desarrollo de Apps Moviles",
    institution: "Google",
    startYear: 2022,
  },
];
export const PROJECTS = [
  {
    title: "myATS",
    year: 2026,
    description:
      "<b>Aplicación web moderna</b> diseñada para crear currículums optimizados para <b>sistemas ATS</b>. Incluye un <b>editor en tiempo real</b>, vista previa dinámica, y un sistema de <b>guía paso a paso</b> para el usuario. Genera archivos PDF profesionales directamente desde el navegador.",
    image: "img/projects/myats.webp",
    link: "https://myats.xyz",
    techs: ["react", "typescript", "tailwindcss"],
  },
  {
    title: "Massive CF",
    year: 2025,
    description:
      "Herramienta de <b>automatización y productividad</b> para Instagram, permitiendo a creadores de contenido y marcas segmentar audiencias de forma masiva en segundos, mejorando el <b>workflow de marketing digital</b> y la gestión de comunidades.",
    image: "img/projects/massivecf.webp",
    techs: ["javascript", "html", "css"],
  },
  {
    title: "Cod-ES",
    year: 2024,
    description:
      "<b>Librería Open-Source</b> de alto impacto educativo que permite programar en Arduino utilizando <b>sintaxis en español</b>, eliminando la barrera idiomática para estudiantes principiante. Proyecto <b>premiado y reconocido</b> por la <b>Dirección General de Cultura y Educación de la Prov. de Buenos Aires</b> por su aporte a la enseñanza tecnológica.",
    image: "img/projects/codes.webp",
    link: "https://github.com/FrancoMartino/Cod-ES",
    openSource: true,
    techs: ["cpp", "arduino"],
  },
  {
    title: "CENDOJ Extractor",
    year: 2024,
    description:
      "Solución de <b>Web Scraping y automatización</b> diseñada para el sector legal. Automatiza la extracción masiva de URLs de sentencias desde el portal CENDOJ (España). <br>Transforma un proceso manual lento en un flujo de trabajo eficiente, facilitando el <b>análisis de datos jurídicos</b> a gran escala.",
    image: "img/projects/cendoj.webp",
    link: "https://github.com/FrancoMartino/cendoj-extractor",
    openSource: true,
    techs: ["javascript", "python", "html", "css"],
  },
  {
    title: "SearchMore Browser Extension",
    year: 2024,
    description:
      "Extensión centrada en la <b>personalización de la experiencia de usuario</b>. Redirige y optimiza el motor de búsqueda predeterminado hacia SearchMore, priorizando la velocidad y la relevancia de los resultados mediante la inyección dinámica de scripts en el navegador.",
    image: "img/projects/searchmore.webp",
    link: "https://searchmore.com",
    techs: ["javascript", "html", "css"],
  },
];
